module.exports = __webpack_public_path__ + "static/media/ic_head10.598f6280.png";